/* ============================================================
   EV Wishlist - lista de favoritos propia (sin apps)
   Guarda handles de producto en localStorage del navegador.
   Piezas: icono con badge en el header, boton en PDP, corazon en las
   product cards, render de la pagina /pages/lista-de-deseos
   (#ev-wishlist-root). Diseño de cards alineado con la PLP del theme.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'ev_wishlist_v1';
  var PAGE_URL = '/pages/lista-de-deseos';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCounters();
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  function money(cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }

  var HEART_OUTLINE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19.5 12.572l-7.5 7.428l-7.5-7.428a5 5 0 1 1 7.5-6.566a5 5 0 1 1 7.5 6.572"/></svg>';
  var HEART_FILLED = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M19.5 12.572l-7.5 7.428l-7.5-7.428a5 5 0 1 1 7.5-6.566a5 5 0 1 1 7.5 6.572"/></svg>';
  var X_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  /* --- Icono de corazon en el header: primero corazon, luego cuenta, luego carrito --- */
  function injectHeaderIcon() {
    var headers = document.querySelectorAll('#shopify-section-header, #shopify-section-mobile-header');
    headers.forEach(function (header) {
      if (header.querySelector('.ev-wl-header-link')) return;
      var cartLink = header.querySelector('a[href$="/cart"], a[href*="/cart?"]');
      if (!cartLink) return;
      var accountBlock = header.querySelector('.account-block');
      var anchor = accountBlock || cartLink.closest('.cart-block') || cartLink;
      var a = document.createElement('a');
      a.href = PAGE_URL;
      a.className = 'ev-wl-header-link';
      a.setAttribute('aria-label', 'Lista de favoritos');
      a.innerHTML = HEART_OUTLINE + '<span class="ev-wl-bubble" hidden></span>';
      anchor.parentNode.insertBefore(a, anchor);
    });
  }

  /* --- Contadores: burbuja del header + enlaces de menu --- */
  function updateCounters() {
    var n = read().length;
    document.querySelectorAll('.ev-wl-bubble').forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
    document.querySelectorAll('a[href*="lista-de-deseos"]:not(.ev-wl-header-link)').forEach(function (a) {
      var badge = a.querySelector('.ev-wl-count');
      if (n > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ev-wl-count';
          a.appendChild(badge);
        }
        badge.textContent = n;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  /* --- Boton en la ficha de producto --- */
  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9\-_%]+)/i);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function paintButton(btn, saved) {
    btn.innerHTML = (saved ? HEART_FILLED : HEART_OUTLINE) + '<span>' + (saved ? 'Guardado en favoritos' : 'Añadir a mis favoritos') + '</span>';
    btn.classList.toggle('ev-wl-saved', saved);
  }
  /* Elige el formulario de compra real (el que tiene boton de anadir al
     carrito). La ficha puede tener otros forms con action /cart/add, por
     ejemplo el de pago a plazos de Shop Pay, que hay que ignorar. */
  function findBuyForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var fallback = null;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.querySelector('button[name="add"], button[type="submit"]:not([name="checkout"]), .product-form__submit, [data-add-to-cart]')) return f;
      if (!fallback) fallback = f;
    }
    return fallback;
  }
  function injectProductButton() {
    var handle = productHandle();
    if (!handle) return;
    var form = findBuyForm();
    if (!form || document.querySelector('.ev-wl-button')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ev-wl-button';
    paintButton(btn, has(handle));
    btn.addEventListener('click', function () {
      toggle(handle);
      repaintHearts(handle);
    });
    form.insertAdjacentElement('afterend', btn);
  }

  /* --- Corazon en las product cards (PLP, home, sliders, recomendados).
     Se inserta en .card__picture-wrapper de cada card con enlace a
     /products/<handle>. Un MutationObserver cubre las cards que el theme
     carga despues (filtros, paginacion, sliders). --- */
  function cardHandle(card) {
    var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([a-z0-9\-_%]+)/i);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function paintHeart(btn, saved) {
    btn.innerHTML = saved ? HEART_FILLED : HEART_OUTLINE;
    btn.classList.toggle('ev-wl-saved', saved);
    /* inline: el theme aplica color a los botones dentro de la card con mas especificidad */
    btn.style.color = saved ? 'rgb(var(--accent-button-color, 235, 247, 187))' : '';
    btn.setAttribute('aria-label', saved ? 'Quitar de favoritos' : 'Añadir a mis favoritos');
    btn.title = saved ? 'Quitar de favoritos' : 'Añadir a mis favoritos';
  }
  function repaintHearts(handle) {
    document.querySelectorAll('.ev-wl-card-heart[data-handle="' + handle + '"]').forEach(function (b) { paintHeart(b, has(handle)); });
    var pdp = document.querySelector('.ev-wl-button');
    if (pdp && productHandle() === handle) paintButton(pdp, has(handle));
  }
  function injectCardHearts(root) {
    (root || document).querySelectorAll('.card__picture-wrapper').forEach(function (wrap) {
      if (wrap.querySelector('.ev-wl-card-heart')) return;
      var card = wrap.closest('.card, .card-container, .product-card') || wrap.parentElement;
      var handle = cardHandle(card);
      if (!handle) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ev-wl-card-heart';
      btn.setAttribute('data-handle', handle);
      paintHeart(btn, has(handle));
      wrap.appendChild(btn);
    });
  }
  /* Los clicks se gestionan en fase de captura a nivel de documento:
     algunas cards (home, sliders, vista rapida) escuchan pointerdown/click
     en el enlace padre y abririan la ficha antes de que el boton reaccione. */
  function bindHeartEvents() {
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (e.target.closest && e.target.closest('.ev-wl-card-heart')) e.stopPropagation();
      }, true);
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.ev-wl-card-heart');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var handle = btn.getAttribute('data-handle');
      toggle(handle);
      repaintHearts(handle);
    }, true);
  }
  /* El drawer y la pagina de carrito comparten la traduccion del boton
     ("Finalizar compra"); en el drawer, mas estrecho, se acorta a "Comprar".
     El drawer se re-renderiza al actualizar el carrito, de ahi el observer. */
  function relabelDrawerCheckout() {
    var btn = document.querySelector('#CartDrawer-Checkout, cart-drawer button[name="checkout"]');
    if (btn && btn.textContent.trim() !== 'Comprar') btn.textContent = 'Comprar';
  }
  function observeCards() {
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; injectCardHearts(); relabelDrawerCheckout(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* --- Pagina de la lista (cards estilo PLP del theme) ---
     La nota informativa se pinta aqui y solo cuando hay productos, para
     no repetir mensaje con el estado vacio. */
  function renderPage() {
    var root = document.getElementById('ev-wishlist-root');
    if (!root) return;
    var list = read();
    if (list.length === 0) {
      root.innerHTML = '<div class="ev-wl-empty">' +
        '<p>Todavía no has guardado nada. Toca el corazón en cualquier producto y aparecerá aquí.</p>' +
        '<a class="ev-wl-cta heading_xs" href="/collections">Descubrir la tienda</a>' +
        '</div>';
      return;
    }
    root.innerHTML = '<p class="ev-wl-note">Se guardan en este dispositivo. Muévelos al carrito cuando quieras.</p><div class="ev-wl-grid"></div>';
    var grid = root.querySelector('.ev-wl-grid');
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
        .then(function (p) {
          var img = (p.images && p.images[0]) ? p.images[0].replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
          var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s class="ev-wl-compare">' + money(p.compare_at_price) + '</s> ' : '';
          var stock = p.available ? '' : '<span class="ev-wl-badge-out">Agotado</span>';
          var vendor = p.vendor ? '<p class="ev-wl-vendor">' + p.vendor + '</p>' : '';
          var card = document.createElement('div');
          card.className = 'ev-wl-card';
          card.innerHTML =
            '<div class="ev-wl-media-wrap">' +
              '<a class="ev-wl-media" href="' + p.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + stock + '</a>' +
              '<button class="ev-wl-remove" aria-label="Quitar de favoritos" title="Quitar de favoritos">' + X_ICON + '</button>' +
            '</div>' +
            '<div class="ev-wl-info">' +
              vendor +
              '<a class="ev-wl-title" href="' + p.url + '">' + p.title + '</a>' +
              '<p class="ev-wl-price">' + compare + money(p.price) + '</p>' +
            '</div>' +
            (p.available
              ? '<button class="ev-wl-add" data-variant="' + p.variants[0].id + '">Añadir al carrito</button>'
              : '<button class="ev-wl-add" disabled>Agotado</button>');
          card.querySelector('.ev-wl-remove').addEventListener('click', function () {
            toggle(handle);
            card.remove();
            if (read().length === 0) renderPage();
          });
          var addBtn = card.querySelector('.ev-wl-add[data-variant]');
          if (addBtn) {
            addBtn.addEventListener('click', function () {
              addBtn.disabled = true;
              addBtn.textContent = 'Añadiendo…';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: Number(addBtn.getAttribute('data-variant')), quantity: 1 })
              }).then(function () { window.location.href = '/cart'; });
            });
          }
          grid.appendChild(card);
        })
        .catch(function () {
          var l = read(); var i = l.indexOf(handle);
          if (i !== -1) { l.splice(i, 1); write(l); }
        });
    });
  }

  function init() {
    injectHeaderIcon();
    updateCounters();
    injectProductButton();
    bindHeartEvents();
    injectCardHearts();
    relabelDrawerCheckout();
    observeCards();
    renderPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.EVWishlist = { toggle: toggle, has: has, all: read };
})();
